export const ERROR_MESSAGE = `Content is not valid`
